import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { BusAuctionFilterService } from '../../../home/services/bus-auction-filter.service';
import { AuctionFilter } from '../../../home/models/auction-filter';
import { DataTableDirective } from 'angular-datatables';
import { LoggingService } from '../../../../services/logging.service';

const apiServer = environment.apiServer;
const apiControl = '/HistoryMailing';

declare var $: any;

@Component({
  selector: 'app-history-mailing-page',
  templateUrl: './history-mailing-page.component.html',
  styleUrls: ['./history-mailing-page.component.sass']
})
export class HistoryMailingPageComponent implements OnInit {
  dataSetExportImportTable: any;
  dtOptionsExportImportTable: DataTables.Settings = {};
  dataSetRegions: any;
  checkedRegion: string[];
  modelAuctionFilter: AuctionFilter = new AuctionFilter();
  spinner: NgxSpinnerService;

  dt: DataTables.Api;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private _spinner: NgxSpinnerService, private loggingService: LoggingService) {
    this.dataSetExportImportTable = [];
    this.checkedRegion = [];
    this.spinner = _spinner;
  }

  ngOnInit() {
    this.spinner.show();

    this.modelAuctionFilter.participant = { value: "all", name: "Все" };

    this.dtOptionsExportImportTable = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      lengthChange: false,
      searching: false,
      autoWidth: true,
      paging: true,
      info: false,
      orderCellsTop: true,
      scrollY: 'calc(100vh - 245px)',

      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.search = this.modelAuctionFilter.search;

        this.http.post<any>(apiServer + apiControl, dataTablesParameters, {})
          .subscribe(resp => {
            if (resp != null) {
              this.dataSetRegions = resp.data;
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: resp.data
              });
            }
            this.spinner.hide();
          });
      },
      columns: [
        { "data": "number", "width": "20px" },
        { "data": "type" },
        { "data": "status" },
        { "data": "email" },
        { "data": "source" },
        { "data": "sentDate" },
        { "data": "distributorName" },
        { "data": "idAuc" },
        { "data": "dateAuc" },
        { "data": "regionName" },
        { "data": "contractorName" },
        { "data": "sumAuc" },
        { "data": "pKP" },
      ],
      columnDefs: [
        {
          targets: 2,
          render: (data) => {
            return `<span class="status-link" style="cursor:pointer; color:#01d3ca;">${data || ''}</span>`;
          }
        }
      ],
      rowCallback: (row: Node, data: any) => {
        const statusCell = $('td:eq(2) .status-link', row); //td:eq(2) - взять 3-ю колонку
        statusCell.off('click'); // удаление старых обработчиков
        statusCell.on('click', () => {
          this.onEmailSendingStatusClick(data.sentDate, data.mailText);
        });
      }
    };
  }

  afterNgFor() {
    $('#exportImportTable').DataTable().columns.adjust();
    $('[data-toggle="popover"]').popover();
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });

  }

  onEmailSendingStatusClick(date, item) {
    const xid = this.loggingService.generateUUID();
    const qualName = `App.Components.HistoryMailingPageComponent.onEmailSendingStatusHover`;
    const inputParams = { date, item };
    const description = 'Отображение письма при нажатии на статус';

    this.loggingService.logStart(xid, qualName, inputParams, `${description} начато`);

    try {
      if (item != null) {
        const modal = $('#messageModal');
        modal.find('.mailBody').text(item.replace(/br/g, '\r\n'));
        modal.find('.modal-title').text('Отправлено ' + date);
        modal.show();
      }

      this.loggingService.logFinish(xid, qualName, inputParams, `${description} завершено`);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, `${description} завершено с ошибкой`);
      throw error;
    }
  }

  onFieldChange(): void {
    const _xid = this.loggingService.generateUUID();

    try {
      this.loggingService.logStart(_xid, 'App.Components.HistoryMailingPageComponent.onFieldChange', null, 'Field change started');

      this.dt.ajax.reload();
      this.dataSetExportImportTable = [];
      this.spinner.show();

      this.loggingService.logFinish(_xid, 'App.Components.HistoryMailingPageComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HistoryMailingPageComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/mailing-list/component/history-mailing-page/history-mailing-page.component.ts